import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function NotVisibleP1Standee({ navigation, primaryDetails, setPrimaryDetails }) {
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
    // Clear error for this field when user starts typing/selecting
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  const validate = () => {
    const newErrors = {
      standee_unvisible_reason: !primaryDetails.standee_unvisible_reason,
    };

    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some(Boolean);

    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validate()) {
      navigation.go('p1-door-hanger-merchandising');
    }
  };

  const handleBack = () => {
    navigation.previous();
  };



  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">NOT VISIBLE P1 STANDEE</h4>
              <p className="form-desc">Please fill in all required details below</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
              <Form>
                {/* Reason P1 standee not visible */}
                <Form.Group className={`mb-4 ${errors.standee_unvisible_reason ? 'form-group-error' : ''}`}>
                  <Form.Label className="form-label">
                    Reason P1 standee not visible <span className="form-required">*</span>
                  </Form.Label>
                  <div className="form-radio-group">
                    {[
                      "HO restriction",
                      "mall restriction",
                      "no Maya customers",
                      "P1/Terminal has been pulled out",
                      "no area to display",
                      "P1/Terminal is not used/boxed",
                      "missing P1 standee",
                      "no P1 standee",
                      "clean store policy",
                      "other reason"
                    ].map((reason) => (
                      <div key={reason} className={`form-radio-item${primaryDetails.standee_unvisible_reason === reason ? " selected" : ""}`}>
                        <div className="form-radio-flex">
                          <Form.Check
                            type="radio"
                            name="standee_unvisible_reason"
                            value={reason}
                            label={reason}
                            checked={primaryDetails.standee_unvisible_reason === reason}
                            onChange={handleChange}
                            className="form-radio"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  {errors.standee_unvisible_reason && (
                    <div className="form-error">
                      Required
                    </div>
                  )}
                </Form.Group>

                {/* Other reason P1 standee not visible */}
                <Form.Group className="mb-4">
                  <Form.Label className="form-label">
                    Other reason P1 standee not visible
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="other_reason_p1_not_visible"
                    value={primaryDetails.other_reason_p1_not_visible || ''}
                    onChange={handleChange}
                    placeholder="Short answer text"
                    className="form-input"
                  />
                </Form.Group>

                <div className="form-nav-btns">
                  <AppButton
                    onClick={handleBack}
                    variant="back"
                    className="form-btn variant-secondary"
                  >
                    ← Back
                  </AppButton>
                  <AppButton
                    onClick={handleSubmit}
                    variant="next"
                    className="form-btn variant-primary"
                  >
                   Next →
                  </AppButton>
                </div>
              </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default NotVisibleP1Standee;